/**
 * The bundle's release, the commit it was built from and when (vite.config.ts
 * stamps them at build time). In the desktop app the screens are built into
 * the app, so this is the app's build too.
 */

declare const __ZITIMAIL_VERSION__: string;
declare const __ZITIMAIL_BUILD__: string;
declare const __ZITIMAIL_BUILT__: string;

// Under the tests nothing is stamped: the defines do not exist.
export const BUILD = {
  version: typeof __ZITIMAIL_VERSION__ === 'string' ? __ZITIMAIL_VERSION__ : '0.0.0',
  build: typeof __ZITIMAIL_BUILD__ === 'string' ? __ZITIMAIL_BUILD__ : 'dev',
  built: typeof __ZITIMAIL_BUILT__ === 'string' ? __ZITIMAIL_BUILT__ : '',
} as const;
